// MUI autocomplete has a bug where focused option has higher styles priority than selected
// We also can't change order of css rule blocks to control specificity because JSS does not allow that
// Resulting CSS will always be
// .MuiAutocomplete-option[aria-selected="true"] {
//   background-color: rgba(255, 255, 255, 0.16);
// }
// .MuiAutocomplete-option[data-focus="true"] {
//   background-color: rgba(255, 255, 255, 0.08);
// }
// .MuiAutocomplete-option:active {
//   background-color: rgba(255, 255, 255, 0.16);
// }
export const autocompleteOverrides = {
  MuiAutocomplete: {
    option: {
      '&[aria-selected="true"]': {
        backgroundColor: 'rgba(255, 255, 255, 0.16)!important',
      },
    },
  },
};
